






import { Component, Prop, Vue } from 'vue-property-decorator'
import { IsMens } from '@/utils/app-setting'

@Component({
  name: 'ErrorMessage'
})
export default class ErrorMessage extends Vue {
  @Prop({ default: null }) public error!: string
  public isMens = IsMens()
  public errorIconPass = require(this.isMens
    ? '@/assets/error_round_red.svg'
    : '@/assets/error_round_blue.svg')
}
